import FormikCheckbox from '@ui-components-3/compat/lib/components/FormikCheckbox'
import FormikRadioGroup from '@ui-components-3/compat/lib/components/FormikRadioGroup'

import TestIds from '../../../util/TestIds'
import PropTypes from 'prop-types'
import keys from 'lodash/keys'
import withForm from '../../../hoc/withForm'
import { LanguageFilters } from '../../../util/languages'
import Modal from '@ui-components-3/ui/lib/components/Modal'

const genderOptions = [
  { value: '', label: 'No preference' },
  { value: 'M', label: 'Male' },
  { value: 'F', label: 'Female' },
  { value: 'X', label: 'Self Selected' },
]

const TherapyProviderFilters = (props) => {
  const { values, onCancel, dirty, isValid, handleSubmit, schema } = props

  return (
    <Modal
      label="If available, what type of provider would you prefer?"
      opened
      onClose={onCancel}
      footer={({ close, idPrefix }) => (
        <>
          <button
            className="btn btn-neutral-outlined"
            data-testid={TestIds.newVisit.button.cancelFilter}
            onClick={close}
            type="button"
          >
            Cancel
          </button>
          <button
            data-testid={TestIds.newVisit.button.applyFilter}
            disabled={!dirty || !isValid}
            className="btn btn-neutral"
            type="submit"
            form={`${idPrefix}form`}
          >
            Apply
          </button>
        </>
      )}
    >
      {({ idPrefix }) => (
        <form onSubmit={handleSubmit} id={`${idPrefix}form`}>
          <div className={'flex w-full flex-wrap gap-2 p-2 text-center'}>
            <p className="typography-body-l text-neutral">Languages</p>
            {keys(values.languages).map((language) => {
              const value = values.languages[language]
              return (
                <div className="w-full" key={language}>
                  <FormikCheckbox
                    data-testid={TestIds.newVisit.input.languageFilter(language)}
                    name={`languages.${language}`}
                    label={LanguageFilters[language]}
                    value={value}
                    schema={schema}
                  />
                </div>
              )
            })}
            <hr className="mb-4 w-full border-gray-300" />
            <div className="w-full">
              <FormikRadioGroup
                data-testid={TestIds.newVisit.input.genderFilter}
                schema={schema}
                name={'gender'}
                options={genderOptions}
                label="Gender"
              />
            </div>

            <hr className="mb-4 w-full border-gray-300" />
            <p className="typography-body-l text-neutral">Ethnicity</p>
            {keys(values.ethnicity).map((race) => (
              <div className="w-full" key={race}>
                <FormikCheckbox
                  name={`ethnicity.${race}`}
                  label={race}
                  schema={schema}
                  data-testid={TestIds.newVisit.input.ethnicityFilter(race)}
                />
              </div>
            ))}
            <hr className="mb-4 w-full border-gray-300" />
            <p className="typography-body-l text-neutral">Specialty</p>
            {keys(values.specialtyFocus).map((focus) => (
              <div className="w-full" key={focus}>
                <FormikCheckbox
                  data-testid={TestIds.newVisit.input.specialtyFilter(focus)}
                  name={`specialtyFocus.${focus}`}
                  label={focus}
                  schema={schema}
                />
              </div>
            ))}
          </div>
        </form>
      )}
    </Modal>
  )
}

TherapyProviderFilters.propTypes = {
  initialValues: PropTypes.object.isRequired,
  schema: PropTypes.object.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  enableReinitialize: PropTypes.bool,
  dirty: PropTypes.bool,
  isValid: PropTypes.bool,
  isLoading: PropTypes.bool,
  pendingVisit: PropTypes.object,
}

export default withForm(TherapyProviderFilters)
